



























































































































































































































































































































































































































































































































































































import {
  Vue,
  Component,
} from "vue-property-decorator";
import CardView from './CardView.vue';
import ButtonGroup from './ButtonGroup.vue';
import CardConent from './CardConent.vue'
import CardConentVertical from './CardConentVertical.vue'
import ListView from './ListView.vue';
import LineView from './lineViews.vue'
import HomePageService from './HomePageService';
import PiePercentView from './PiePercentView.vue'
import NoticeViewSecond from '../notice/NoticeViewSecond.vue'
import NoticeViews from './NoticeView.vue'
import echart from 'echarts';
// import NoticeView from '../notice/NoticeView.vue'
@Component({
  components: {CardView,ButtonGroup,CardConent,ListView,CardConentVertical,PiePercentView,NoticeViewSecond,NoticeViews,LineView}
})
export default class HomePageSecond extends Vue {
  public upSrc = "https://lanhu-oss.lanhuapp.com/SketchPngfe75134cd11aba390c9f6d2d754904a57e951c9858ff972d2b32952e15228874"
  public downSrc = "https://lanhu-oss.lanhuapp.com/SketchPng7b91455149d1650ebbdbf26e1d289b65cc4fba4c5f3949f2766e077b8acc8863"
  public isShow = true
  public isShowTwo = true
  public handleCommand (command:any) {
    console.log('com',command)
    if (command == 'a') {
      this.isSelectedStr = '回执工单'
      this.isShow = true
      this.isShowTwo = false
    } else {
      this.isSelectedStr = '服务满意度'
      this.isShow = false
      this.isShowTwo = true
      setTimeout(() => {
        //@ts-ignore
        this.myCharts.resize() 
      },100)
    }
  }
  public isSelectedStr = '回执工单'
  public handleClick(tab:any, event:any) {
        console.log(tab, event);
  } 
  public activeName = 'first'
  public GroupName = {
    OVERVIEW : 'OVERVIEW',
    NETWORK : 'NETWORK'
  }
  public buttonGroupType = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    QUARTER: 'quarter'
  }

    public middleHeight = 343 - 4.5;

    public a : String = '/assets/png/报警.png'
    public b : String = '/assets/png/备件工单补库量.png'
    public c : String = '/assets/png/待上门工单量.png'
    public d : String = '/assets/png/工程师领用量.png'
    public e : String = '/assets/png/回执工单量.png'
    public f : String = '/assets/png/收益.png'
    public g : String = '/assets/png/投诉量.png'
    public h : String = '/assets/png/遗留量.png'
    public buttonParam:Array<any> = [{key: "day",value:"日"},{key: "week",value:"周",isActive: true},{key: "month",value:"月"}]
    public buttonParam1:Array<any> = [{key: "month",value:"月",isActive: true},{key: "quarter",value:"季"}]

    public todoList:Array<any> = [];
    public messageList:Array<any> = [];
    public noticeList:Array<any> = [];
    public noticeVisible: boolean = false;
    public noticeId: string = '';

    public menuJumpTo(item: any) {
            const tempThis = this as any;
            tempThis.$bus.$emit('openMenuFromHome',item.label);
        }

    // 接单处理、服务商结算、激励申诉、服务商采购单、采购入库、工程师领用、工程师归还、员工档案
    public quickAccessData : Array<any> = [
      {img:'/assets/png/quick/接单处理.png',label: '工单待处理', router: '',},
      {img:'/assets/png/quick/服务商结算.png',label: '服务商结算', router: ''},
      {img:'/assets/png/quick/激励申诉.png',label: '激励申诉',  router: ''},
      {img:'/assets/png/quick/服务商采购单.png',label: '服务商采购单', router: ''},
      {img:'/assets/png/quick/采购入库.png',label: '采购入库单', router: ''},
      {img:'/assets/png/quick/工程师领用.png',label: '工程师领用单', router: ''},
      {img:'/assets/png/quick/工程师归还.png',label: '工程师归还单', router: ''},
      {img:'/assets/png/quick/员工档案.png',label: '员工档案', router: ''},
    ]

    public visitForm: number = 0;
    public receiptForm: number = 0;
    public leaveOver: number = 0;
    public complain: number = 0;
    public earlyWarning: number = 0;
    public engineerReceive: number = 0;
    public replenishment: number = 0;
    public ServiceRevenue: number = 0;

    public buttonClick(value : any) {
        if(value.groupName == this.GroupName.OVERVIEW) {
            this.getVisitForm(value.key);
            this.getReceiptForm(value.key);
            this.getLeaveOver(value.key);
            this.getComplain(value.key);
        } else if (value.groupName == this.GroupName.NETWORK) {
           // todo refresh
        }
    }
    public testdata = ["蓝键盘","张三","李四","王五","力气","王哥","赵姐",]
    public testdatatwo = [5, 20, 36, 10, 10, 20, 100]
    public myChart = null
    public myCharts = null
    public drawTwo() {
          // 基于准备好的dom，初始化echarts实例
          //@ts-ignore
  this.myChart = echart.init(document.getElementById('main') as any);
  //@ts-ignore
  this.myCharts = echart.init(document.getElementById('mains') as any);
  let _this = this
  // 指定图表的配置项和数据
  var option = {
      color: '#37A2FF',
      title: {
          text: ''
      },
      // tooltip: {
      //     trigger: 'item'
      // },
      tooltip: {
                trigger: 'item',
                axisPointer: {
      type: "shadow"
    }
              },
      legend: {
          data:['回执工单量']
      },
          dataZoom: [{
              type: this.allData.workOrderReceiptCount.length <= 16 ?'inside' :'slider', // 设置为滑动条型式
              show: true, // 显示dataZoom组件
              disabled: true,
              start: 0, // 默认显示的起始位置为0
              end: this.allData.workOrderReceiptCount.length <= 16 ?'100' :'40', // 默认显示的结束位置为100
              handleSize: 1, // 滑动条的手柄大小
              handleStyle: {
              color: '#f3f3f3' // 滑动条的手柄颜色
              },
              xAxisIndex: [0], // 表示控制第一个x轴
            filterMode: 'filter' // 设置为filter模式，即数据超过范围时会被过滤掉
          }],
      xAxis: {
         //@ts-ignore
          data: this.allData.workOrderReceiptCount?.map(value => value.employee_name),
          axisLabel : {
                      // rotate: 40,
                      width:10,
                      interval: 0,
                      margin:9,
                      fontWeight: "bolder"
                  }
      },
      yAxis: {
              boundaryGap: [0, 0]
      },
      series: [{
          name: '回执工单量',
          type: 'bar',
          //@ts-ignore
          data: this.allData.workOrderReceiptCount?.map(value => value.cnt),
          barWidth:'20%',
          markLine: {
              label:{
                position : 'end',
                color:'red',
                formatter: function(value:any) {
                  return `全国平均值 [${_this.allData.averageWorkOrderReceiptCount.toFixed(2)}]`
                }
              },
              lineStyle: {
            color:'red',
            type:'dashed'
          },
              silent:false,
              data: [
                      {
                type: 'average',
                name: '全国平均值',
                // yAxis: 2,
                yAxis: this.allData.averageWorkOrderReceiptCount.toFixed(2),
              //把平均线的位置也设为平均值
              },
              ]
          },
          
      },
      ]
  };
  var options = {
      color: '#37A2FF',
      title: {
          text: ''
      },
      // tooltip: {
      //     trigger: 'item'
      // },
      tooltip: {
                trigger: 'axis',
                axisPointer: {
      type: "line"
    }
              },
      legend: {
          data:['服务满意度']
      },
          dataZoom: [{
              type: this.allData.serviceSatisfaction.length <= 16 ?'inside' :'slider', // 设置为滑动条型式
              show: true, // 显示dataZoom组件
              disabled: true,
              start: 0, // 默认显示的起始位置为0
              end: this.allData.serviceSatisfaction.length <= 16 ?'100' :'40', // 默认显示的结束位置为100
              handleSize: 1, // 滑动条的手柄大小
              handleStyle: {
              color: '#f3f3f3' // 滑动条的手柄颜色
              },
              xAxisIndex: [0], // 表示控制第一个x轴
            filterMode: 'filter' // 设置为filter模式，即数据超过范围时会被过滤掉
          }],
      xAxis: {
         //@ts-ignore
          data: this.allData.serviceSatisfaction?.map(value => value.employee_name),
          axisLabel : {
                      // rotate: 40,
                      width:10,
                      interval: 0,
                      margin:9,
                      fontWeight: "bolder"
                  },
                  boundaryGap: false,
      },
      yAxis: {
              // boundaryGap: [0, 5]
              min:0,
              max:120,
              
      },
      series: [{
          name: '服务满意度',
          type: 'line',
          //@ts-ignore
          data: this.allData.serviceSatisfaction?.map(value => value.cnt),
          barWidth:'20%',
          markLine: {
              label:{
                position : 'end',
                color:'red',
                formatter: function(value:any) {
                  return `全国平均值 [${_this.allData.averageServiceSatisfaction.toFixed(2)}]`
                }
              },
              lineStyle: {
            color:'red',
            type:'dashed'
          },
              silent:false,
              data: [
                      {
                type: 'average',
                name: '全国平均值',
                // yAxis: 2,
                yAxis: this.allData.averageServiceSatisfaction.toFixed(2),
              //把平均线的位置也设为平均值
              },
              ]
          },
          
      },
      ]
  };
  //@ts-ignore
  this.myChart.setOption(option);
    //@ts-ignore
  this.myCharts.setOption(options);
  
      }
      public getHomePageAllData () {
        HomePageService.getHomePageAllData().then(res => {
         if(res.data) {
           console.log(res)
           this.allData = res.data
          //  let num = 0
          //  this.allData.workOrderReceiptCount.forEach((item:any) => {
          //   num += item.cnt
          //  })
          //  this.allData.averageServiceSatisfaction = (num/ this.allData.workOrderReceiptCount.length).toFixed(1)
          //  console.log(num)
           this.drawTwo();
                  this.isShowTwo = false
         }
       })
      }
      // public getSpHomePageAllData () {
      //   HomePageService.getSpHomePageAllData().then(res => {
      //    if(res.data) {
      //      this.allSpData = res.data
      //    }
      //  })
      // }
      public allData:any = {}
      public allSpData:any = {}

    created() {
      this.getVisitForm(this.buttonGroupType.WEEK);
      this.getReceiptForm(this.buttonGroupType.WEEK);
      this.getLeaveOver(this.buttonGroupType.WEEK);
      this.getComplain(this.buttonGroupType.WEEK);
      this.getServiceProviderDayEngineerReceive();
      this.getHomePageAllData();
      // this.getSpHomePageAllData();
      this.getServiceRevenue();
      this.ServiceProviderCountwonum();
      // this.drawTwo();
      setTimeout(() => {
                  // this.draw();
                  
              }, 100);

      this.getNotice({size: 5,n_client_type_eq:'pc'});
      this.getToList({ pageBean: {
              page: 1,
              pageSize: 5
          }});
      this.getMessageList({size: 5,page: 0,sort: 'create_date,desc'})
       //@ts-ignore
      this.$bus.$on('isread',(e:any)=> {
        if (e) {
           this.getNotice({page:0,size: 5,n_client_type_eq:'pc'});
        }
      })
    }


    /**
     * 数据请求赋值
     */
         /**
      * 待上门工单量
      */
     public getVisitForm(type: string){
       HomePageService.ServiceProviderWaitDoor(type).then(res => {
         if(res.data) {
           this.visitForm = res.data || 0;
         }
       })
     }
     /**
      * 已回执工单量
      */
     public getReceiptForm(type: string) {
          HomePageService.ServiceProviderReceipt(type).then(res => {
          if(res.data) {
           this.receiptForm = res.data || 0;
         }
       })
     }
    /**
      * 超期遗留量
      */
     public getLeaveOver(type: string) {
          HomePageService.ServiceProviderOverdue(type).then(res => {
          if(res.data) {
           this.leaveOver = res.data || 0;
         }
       })
    }
    /**
      * 投诉量
      */
     public getComplain(type: string) {
         HomePageService.ServiceProviderComplain(type).then(res => {
         if(res.data) {
           this.complain = res.data || 0;
         }
       })
    }
    /**
     * 工单收益
     */
    public getServiceRevenue(){
        HomePageService.ServiceProviderOrderIncome().then(res => {
         if(res.data) {
           this.ServiceRevenue = res.data || 0;
         }
       })
    }
    /**
     * 服务商当日工程师领用数量
     */
    public getServiceProviderDayEngineerReceive(){
       HomePageService.ServiceProviderDayEngineerReceive().then(res => {
         if(res.data) {
           this.engineerReceive = res.data || 0;
         }
       })
    }
        /**
     * 今日备件工单补库量
     */
    public ServiceProviderCountwonum(){
       HomePageService.ServiceProviderCountwonum().then(res => {
         if(res.data) {
           this.replenishment = res.data || 0;
         }
       })
    }



    /**
     * 公告通知
     */
    public getNotice(param : Object) {
      HomePageService.getNotice(param).then(res => {
        if (res.data && res.data.length > 0) {
          this.noticeList = res.data;
        } else {
          this.noticeList = [];
        }
      })
    }

         /**
     * 公告点击事件
     */
    public noticeRightClick(data : any) {
      this.noticeVisible = true;
      this.noticeId = data.mpnoticeid;
      setTimeout(()=>{
        this.getNotice({size: 5,n_client_type_eq:'pc'});
      },1000)
    }

    /**
     * 消息预警点击事件
     */

    public messageRightClick(data : any) {
      this.$confirm(data.msginfo, '消息内容', {
            confirmButtonText: '确定',
            type: "success",
            showCancelButton:false
        })
      try {
        this.$http.post(`/runtimeapi/readWebMsg/${data.msgsendid}`,{})
      } catch (error) {

      } finally{
        setTimeout(()=>{
          this.getMessageList({size: 5,page: 0,sort: 'create_date,desc'})
        },1000)
      }
    }

    /**
     *  公告more
     */
    public noticeMore(){
      this.$router.push('/appindexview/null/notice-table')
    }
    /**
     * 消息预警more
     */

    public messageMore(){
      this.$router.push('/appindexview/null/message-table')
    }

        /**
     * 待审批列表
     */

    public todoMore(){
      this.$router.push('/appindexview/null/todoTask')
    }



    /**
     *  公告弹窗关闭回调
     */


    public noticeViewClose() {
       this.noticeVisible = false;
    }

    /**
     * 待审批列表
     */
    public getToList(param: object) {
      HomePageService.getToList(param).then(res => {
        if (res.data && res.data.value.rows.length > 0) {
          this.todoList = res.data.value.rows;
        } else {
          this.todoList = [];
        }
      })
    }
    //跳转css的工程项目详情页
    public jumpBasic(data:any){
      let routePath=`/cssbd/null/bdprojects/${data.id}/editview?bdprojectid=${data.id}`
      this.$router.push(routePath)
      window.postMessage({
          type: 'singleRoute',
          data: {
              current: JSON.stringify(Object.assign({}, {
                  fullPath: routePath,
                  path: routePath.replace(/\?.*/g, '')
              }))
          }
      }, window.location.origin)
    }

  public handleTodoTask(data: any) {
    if(data.type=='css'){
      this.jumpBasic(data)//跳转css的工程项目详情页
      return
    }
    let user: any = JSON.parse(window.localStorage.getItem("user") as any) ;
    if(user?.sessionParams?.extusertype === '2'){
      if(data.outTaskUrl){
        HomePageService.getOASignUrl(data.outTaskUrl).then((res) => {
          if (res && res.data) {
            let url = res.data.value+'&ssoCode=[ssoCode]';
            let token: string = window.sessionStorage.getItem("token") as any;
            HomePageService.getSSOCode(token).then((res) => {
              if (res && res.data) {
                url = url.replace("[ssoCode]", res.data);
                window.open(url);
              }
            });
          }
        }).catch((err: any) => {
          alert("请求OA数据错误:"+err?.data?.error)
        });
      }
    }else{
      let token: string = window.sessionStorage.getItem("token") as any;
      HomePageService.getSSOCode(token).then((res) => {
        if (res && res.data) {
         let url = data.taskUrl.replace("[ssoCode]", res.data);
          window.open(url);
        }
      });
    }
  }


    /**
     * 消息预警
     */
    public getMessageList(param: object) {
      HomePageService.getMessage(param).then(res => {
        if (res.data && res.data.length > 0) {
          this.messageList = res.data;
        } else {
          this.messageList = [];
        }
      })
    }

    public getLevel(level : string) {
      if (level == '高') return 'danger';
      if (level == '中') return 'warning';
      if (level == '低') return 'success';
    }

    public formatDate(param : any){
      return HomePageService.formatDate(param);
    }

}
